<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.lhlb">
      </p>
      <p>
        <br>
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <u>
            <span style="font-size:16.0pt;font-family:宋体;">联合拉拔精整机组</span>
          </u>
        </b>
        <b>
          <u>
            <span style="font-size:16.0pt;font-family:Arial;"></span>
          </u>
        </b>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">&nbsp;</span>
      </p>
      <div>
        <table align="left" cellpadding="0" cellspacing="0">
          <tbody>
            <tr>
              <td align="left" valign="top">
                <p>
                  <span
                    style="font-size:12.0pt;font-family:宋体;color:#2F3032;"
                  >联合拉拔机组是广泛应用于有色和黑色行业的管、棒材加工设备。我公司在消化吸收国外技术的基础上研制开发了</span>
                  <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">20</span>
                  <span style="font-size:12.0pt;font-family:宋体;color:#2F3032;">～</span>
                  <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">150KN</span>
                  <span
                    style="font-size:12.0pt;font-family:宋体;color:#2F3032;"
                  >双面圆柱凸轮联合拉拔机组系列产品，具有多项专利技术，可根据用户要求采用单联拉、串联式双联拉或三联拉配置。</span>
                  <span style="font-size:12.0pt;font-family:宋体;">我公司产品远销乌克兰等国家。</span>
                  <span style="font-size:12.0pt;font-family:Arial;"></span>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">
          <br>
        </span>
        <b>
          <span style="font-size:12.0pt;font-family:宋体;color:#2F3032;">主要特点如下</span>
        </b>
        <b>
          <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">
            <br>
          </span>
        </b>
        <span style="font-size:12.0pt;font-family:宋体;color:#2F3032;">
          <span>★</span>采用机电液一体化设计，通过人机交互式操作，实现生产自动化。
        </span>
        <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">
          <br>
        </span>
        <span style="font-size:12.0pt;font-family:宋体;color:#2F3032;">
          <span>★</span>拉拔小车换手由凸轮及闭式液压回路控制，反应灵敏、可靠。
        </span>
        <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">
          <br>
        </span>
        <span style="font-size:12.0pt;font-family:宋体;color:#2F3032;">
          <span>★</span>配有自动和手动两种操作模式，以满足生产线的不同工艺要求。
        </span>
        <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">
          <br>
        </span>
        <span style="font-size:12.0pt;font-family:宋体;color:#2F3032;">
          <span>★</span>可一次装入多个芯头而只打一次头，减少了材料消耗并可实现高速连续拉拔。
        </span>
        <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">
          <br>
        </span>
        <span style="font-size:12.0pt;font-family:宋体;color:#2F3032;">
          <span>★</span>单道次拉伸的延伸系数可达
        </span>
        <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">λ=1.5</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#2F3032;">～</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">1.8</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#2F3032;">。</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">
          <br>
        </span>
        <span style="font-size:12.0pt;font-family:宋体;color:#2F3032;">
          <span>★</span>
        </span>
        <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">&nbsp;</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#2F3032;">可实现管坯的盘到盘、盘到直的定尺拉拔等多种生产方案，工艺灵活。</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">
          <br>
        </span>
        <span style="font-size:12.0pt;font-family:宋体;color:#2F3032;">
          <span>★</span>
        </span>
        <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">&nbsp;</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#2F3032;">直拉与盘拉相比具有更好的壁厚偏差和圆度。</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">
          <br>
        </span>
        <span style="font-size:12.0pt;font-family:宋体;color:#2F3032;"></span>
        <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;"></span>
      </p>
      <p>
        <b>
          <span style="font-size:12.0pt;font-family:宋体;color:#2F3032;">设备组成</span>
        </b>
        <b>
          <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">
            <br>
          </span>
        </b>
        <span
          style="font-size:12.0pt;font-family:宋体;color:#2F3032;"
        >串联式联合拉拔机组由机械设备、润滑设备、电气系统、液压及气动系统等组成。机械设备包括开卷、矫直夹送、压头、拉拔主机、冷却、缓冲活套、剪切、收卷装置（或定尺飞锯）等。</span>
      </p>
      <p>
        <br>
      </p>
      <p>
        <br>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        lhlb: require("../../../assets/img/common/lhlb.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/zh/device/lhlb.vue